import React from 'react';
import { motion } from 'framer-motion';
import { Target, Zap, Shield } from 'lucide-react';
export function About() {
  return <section className="py-12 relative z-10" data-id="element-8">
      <div className="max-w-7xl mx-auto px-6" data-id="element-9">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-10">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="relative" data-id="element-11">
            <div className="relative rounded-2xl overflow-hidden glass-card p-1.5" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/amq8kszkUzSezELafPzJTk/IMG_3592_(2).png" alt="Andres Castro — Sistema de Ingresos 360" className="w-full rounded-xl object-cover" data-id="element-13" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-transparent to-transparent opacity-40 pointer-events-none" data-id="element-14" />
            </div>
            {/* Decorative glow */}
            <div className="absolute -inset-4 bg-brand-cyan/10 rounded-3xl blur-3xl -z-10" data-id="element-15" />
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-card mb-6 border-brand-cyan/20" data-id="element-17">
              <span className="w-2 h-2 rounded-full bg-brand-cyan animate-pulse" data-id="element-18" />
              <span className="text-brand-cyan text-sm font-medium tracking-wide uppercase" data-id="element-19">
                Sobre El Operador
              </span>
            </div>

            <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-20">
              Construyendo el futuro de los{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-cyan to-white/60" data-id="element-21">
                ingresos digitales
              </span>
            </h2>

            <p className="text-white/60 leading-relaxed mb-6 text-lg" data-id="element-22">
              Emprendedor digital, trader e instructor especializado en la nueva
              economía. He ayudado a cientos de personas a construir sistemas de
              ingresos predecibles combinando Inteligencia Artificial, Ventas
              Digitales y Trading Institucional.
            </p>

            <p className="text-white/60 leading-relaxed mb-8" data-id="element-23">
              Mi misión es democratizar el acceso a las herramientas y
              estrategias que realmente generan resultados en el mundo digital.
              El Sistema de Ingresos 360 es la culminación de años de
              experiencia práctica en los tres pilares de la nueva economía.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-24">
              {[{
              icon: Target,
              label: 'Enfoque',
              value: 'Resultados'
            }, {
              icon: Zap,
              label: 'Método',
              value: 'Práctico'
            }, {
              icon: Shield,
              label: 'Acceso',
              value: 'Acceso Anual + Updates 2026'
            }].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3 + index * 0.1
            }} className="glass-card rounded-xl p-4 text-center" data-id="element-25">
                  <item.icon className="w-5 h-5 text-brand-cyan mx-auto mb-2" data-id="element-26" />
                  <p className="text-white/40 text-xs uppercase tracking-wider mb-1" data-id="element-27">
                    {item.label}
                  </p>
                  <p className="text-white font-display font-bold" data-id="element-28">
                    {item.value}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}